import JobClosedReason from '@/models/Jobs/JobClosedReason';

export default class JobClosedReasonViewModel {
    name: string;
    value: JobClosedReason;

    public constructor(name: string, value: JobClosedReason) {
        this.name = name;
        this.value = value;
    }
}